import React from "react";

// Imports
import SimpleWrapper from "../components/SimpleWrapper";
import BestInClassMarketplace from "../components/BestInClassMarketplace";
import OurPartners from "../components/OurPartners";
import WhyChoose from "../components/WhyChoose";
import HowItWorks from "../components/HowItWorks";
import ProductFilter from "../components/ProductFilter";

const AboutUs = () => {
  return (
    <SimpleWrapper searchVisible={false} navigation={false}>
      <BestInClassMarketplace />
      <OurPartners />
      <WhyChoose />
      <HowItWorks />
    </SimpleWrapper>
  );
};

export default AboutUs;
